import Layout from '@/views/layout'

export default [
  {
    path: '/downloadCenter',
    name: 'downloadCenter',
    redirect: '/downloadCenter/index',
    component: Layout,
    meta: {
      title: '下载中心',
      icon: 'down.png',
      index: 14
    },
    children: [
      {
        path: 'index',
        name: 'index',
        meta: {
          title: '下载中心'
        },
        component: () => import('@/views/downloadCenter')
      }
    ]
  }
]